import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";
import React from "react";

const BellIconSvg: React.FC<Partial<CustomIconComponentProps>> = (props) => (
  <svg
    width="18"
    height="20"
    viewBox="0 0 18 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.99927 0.832031C9.69559 0.83209 10.292 1.25874 10.5413 1.86523C12.9623 2.50851 14.7916 4.63002 15.051 7.21191C15.1727 8.42318 15.315 9.66919 15.4709 10.708C15.6412 11.8417 16.2088 13.3093 16.7952 14.5928C17.5566 16.2597 16.4013 18.3319 14.4631 18.332H10.2493C10.249 18.7919 9.87613 19.1648 9.41626 19.165H8.58228C8.12228 19.1649 7.74952 18.792 7.74927 18.332H3.5354C1.59715 18.332 0.441842 16.2598 1.20337 14.5928C1.78968 13.3093 2.35634 11.8417 2.52661 10.708C2.68259 9.66919 2.82583 8.42318 2.94751 7.21191C3.2069 4.63003 5.03628 2.50851 7.45728 1.86523C7.70653 1.25875 8.30293 0.832031 8.99927 0.832031ZM8.99927 3.33203C6.7324 3.33203 4.83547 5.09174 4.60571 7.37891C4.48293 8.60116 4.33686 9.87739 4.17505 10.9551C3.96795 12.3344 3.31538 13.9818 2.71997 15.2852C2.41846 15.9452 2.91535 16.665 3.5354 16.665H14.4631C15.0831 16.6649 15.58 15.9451 15.2786 15.2852C14.6831 13.9817 14.0306 12.3344 13.8235 10.9551C13.6617 9.87739 13.5156 8.60117 13.3928 7.37891C13.1631 5.09179 11.2661 3.33211 8.99927 3.33203Z"
      fill="black"
      fillOpacity="0.85"
    />
  </svg>
);

export const BellIcon: React.FC<Partial<CustomIconComponentProps>> = (
  props,
) => <Icon component={BellIconSvg} {...props} />;
